/**
 * Enum for organization switcher events
 */
export enum OrganizationSwitcherEvents {
  ORGANIZATION_SWITCHED = 'organization_switched',
  ORGANIZATION_LOADED = 'organization_loaded',
  ORGANIZATION_ERROR = 'organization_error'
}

/**
 * Enum for organization switcher states
 */
export enum OrganizationSwitcherState {
  IDLE = 'idle',
  LOADING = 'loading',
  LOADED = 'loaded',
  ERROR = 'error',
  SWITCHING = 'switching'
}
